import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight, Mail } from "lucide-react";
import { FALLBACK_TICKET_URL } from "../../lib/api";
import { useLang, T } from "../../lib/i18n";

export const Footer = ({ settings }) => {
  const url = settings?.ticket_url || FALLBACK_TICKET_URL;
  const { lang } = useLang();
  const t = T[lang].footer;
  return (
    <footer data-testid="site-footer" className="bg-[#0B2530] text-white overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-24 md:pt-32 pb-10">
        <p className="text-xs uppercase tracking-[0.3em] text-[#7BDFF2] mb-6">{t.dates}</p>
        <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight max-w-4xl">
          {t.seeYou1} <span className="italic text-[#7BDFF2]">{t.seeYou2}</span>
        </h2>
        <a
          href={url}
          target="_blank"
          rel="noopener"
          data-testid="footer-buy-tickets"
          className="group mt-10 inline-flex items-center gap-3 rounded-full bg-[#00B4D8] hover:bg-[#33c5e2] text-white text-sm uppercase tracking-[0.2em] px-10 py-5 transition-colors duration-300"
        >
          {t.buy}
          <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>

        <div className="mt-20 md:mt-28 grid grid-cols-1 md:grid-cols-3 gap-10 border-t border-white/10 pt-10">
          <div className="flex flex-col gap-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/40">{t.events}</p>
            <Link data-testid="footer-link-gala" to="/events/new-year-gala" className="text-white/70 hover:text-white transition-colors duration-300 w-fit">{t.gala}</Link>
            <Link data-testid="footer-link-afterparty" to="/events/afterparty" className="text-white/70 hover:text-white transition-colors duration-300 w-fit">{t.afterparty}</Link>
            <Link data-testid="footer-link-first-sunset" to="/events/first-sunset" className="text-white/70 hover:text-white transition-colors duration-300 w-fit">{t.sunset}</Link>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/40">{t.follow}</p>
            <div className="flex gap-4">
              <a data-testid="footer-instagram" href={settings?.instagram || "https://www.instagram.com/vsenashinyc?igsi=ZTRianU0dXZkYzJw"} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="inline-flex items-center gap-3 rounded-full border border-white/15 hover:border-[#7BDFF2] hover:text-[#7BDFF2] transition-colors duration-300 px-5 py-3">
                <Instagram size={18} /> <span className="text-sm">@vsenashinyc</span>
              </a>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <p className="text-xs uppercase tracking-[0.25em] text-white/40">{t.contact}</p>
            <a data-testid="footer-email" href={`mailto:${settings?.contact_email || "sxm@vse-nashi.com"}`} className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-300 w-fit">
              <Mail size={16} /> {settings?.contact_email || "sxm@vse-nashi.com"}
            </a>
            <p className="text-white/40 text-sm">Kalos Beach Restaurant · Villa Aura, Anse Marcel · Saint Martin</p>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/30">
          <p>{t.rights}</p>
          <p>{t.tickets}</p>
        </div>
      </div>
    </footer>
  );
};
